import { render } from "./water.svg?vue&type=template&id=9b45ebcc?inline"
const script = {}

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__